<template>
  <div class="confirmation-summary--property">
    <ConfirmationSummaryRow label="Inspection Address:" class="property-address">
      <template v-if="address">
        <span>{{address.address1}}</span>
        <span v-if="address.address2">{{address.address2}}</span>
        <span>{{address.city}}, {{address.state}} {{address.postalCode}}</span>
      </template>
    </ConfirmationSummaryRow>

    <ConfirmationSummaryRow v-if="model.customerComments" label="Additional Instructions:">
      <span>"{{model.customerComments}}"</span>
    </ConfirmationSummaryRow>
  </div>
</template>

<script>
import ConfirmationSummaryRow from '@/components/ConfirmationSummaryRow.vue';

export default {
  components: {
    ConfirmationSummaryRow,
  },
  props: {
    model: {
      type: Object,
      required: true,
    },
  },
  computed: {
    address() {
      return this.model && this.model.address;
    },
  },
};
</script>

<style lang="scss" scoped>
.property-address {
  span {
    display: block;
  }
}
</style>
